__turbopack_context__.v({
  "className": "ykxj-G_className",
  "variable": "ykxj-G_variable",
});
